import * as React from 'react';
export function Line(_a) {
    var _b;
    var data = _a.data, lineGenerator = _a.lineGenerator, stroke = _a.stroke, opacity = _a.opacity;
    return (React.createElement("path", { className: "Chart--SVGLine Line--type-line", fill: "none", strokeLinecap: "round", stroke: stroke !== null && stroke !== void 0 ? stroke : '#9980FA', d: (_b = lineGenerator(data)) !== null && _b !== void 0 ? _b : '', opacity: opacity !== null && opacity !== void 0 ? opacity : 1 }));
}
//# sourceMappingURL=Line.js.map